export default function FORM_VALIDATE(){
	window.gpFormValidation = function($form){
		var errorClass = 'js-valid-error';
		var msg ={
			container:'<p class="needs font-size-small text-error '+errorClass+'">',
			require:'※必須項目が入力されていません。',
			email:'※メールアドレスの形式を確認して下さい。',
			file: '※添付ファイルのサイズが既定値を超えています。',
			filesum: '※添付ファイルの合計サイズが既定値を超えています。'
		};
		var check = function(){
			var result = true;

			//表示されているエラーを非表示
			$('.'+errorClass,$form).remove();

			//必須チェック
			$(':input[required],:input[data-required],select[required]',$form).each(function(){
				var thisName = $(this).attr('name');
				var thisData = $('[name="'+thisName+'"]').serialize();
				var $errDispContainer = $(this).closest('dd');

				// プルダウンの複数項目はnameが一緒なので個別にシリアライズ
				if( $(this).is('select') ) thisData = $(this).serialize();

				//nameとvalueの配列に変換
				thisData = thisData.split('=');

				// タイプごとにデータを補完
				var type = $(this).attr('type');
				if(type=='checkbox' || type=='radio' || $(this).is('[multiple]')) thisData.unshift($(this).attr('name'));
				if(type=='file') thisData[1] = $(this).val();
				if($(this).is('[multiple]')) thisData[1] = $(this).val()||'';

				// 入力されたデータが無い、もしくはエラーがすでに出ていなければエラーメッセージ表示
				// console.log('%s is %o',thisName,thisData);
				if(thisData[1]=='' && $errDispContainer.find('.'+errorClass).length == 0){
					$errDispContainer.prepend($(msg.container).text(msg.require));
					result = false;
				}
			});

			//E-mailチェック
			var $email = $('[name=GetEmail]');
			if($email.val() && !$email.val().match(/^[A-Za-z0-9]+[\w\.-]+@[\w\.-]+\.\w{2,}$/) ){
				$email.closest('dd').prepend($(msg.container).text(msg.email));
				result = false;
			}

			// ファイルサイズチェック
			var maxfilesize = $('input[name="validate_maxfilesize"]').val()*1000 || 5000000,
					maxmessage = '(最大'+(maxfilesize/1000000).toFixed(1)+'MB)',
					sum_filesize = 0,
					sum_error_flg = false,
					$file = $('input[type="file"]');
			$file.each(function(){
				if(!this.files.length) return;
				sum_filesize += this.files[0].size;
				if(this.files[0].size >= maxfilesize ){
					$(this).before($(msg.container).text(msg.file+maxmessage));
					result = false;
				}
				if(sum_filesize >= maxfilesize && !sum_error_flg){
					$('input[name="validate_maxfilesize"]').before('<tr class="filesumerror '+errorClass+'"><dd colspan="2"/></tr>');
					$('.filesumerror dd').prepend($(msg.container).text(msg.filesum+maxmessage));
					sum_error_flg = true;
					result = false;
				}
			});
			
			return result;
		};

		// クリック時の動作
		$(document).on('click','[type=submit]',function(){
			var result = check();

			// エラーがある箇所にスクロール
			if( $('.'+errorClass).length && !result ){
				var pos = $('.'+errorClass).eq(0).offset().top -24;
				$('html,body').animate({scrollTop:pos},'fast');
			}
			return result;
		});
	};
}